import Backbone from 'backbone'
import LabeledToggle from 'scoreboard/components/labeled-toggle'
import _ from 'lodash'
import FormView from 'scoreboard/components/form-view'
import enums from 'scoreboard/components/enums'
import template from './legend-settings.hbs'
import i18n from 'scoreboard/components/i18n'
import formHelper from 'scoreboard/components/form-helper'
import dropdown from 'scoreboard/components/dropdown'
import conductor from 'scoreboard/components/conductor'


const LegendSettings = Backbone.View.extend({

	tagName: 'form',

	className: 'legend-settings',

	events: {
		'change [name=abbreviateLegendValues]': 'togglePrecisionSelect'
	},

	initialize: function(options) {
		this.options = options || {}
		this.setting = this.options.setting
		this.section = this.options.section || conductor.section()
		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this)
		})
	},

	render: function() {
		this.$el.empty().append(template(this.context()))
		this.renderPrecisionDropdown()
		this.renderDisplayToggle()

		formHelper.writeToDom(this.setting, this.el)
		if (this.setting.plotType !== 'filled-map') {
			this.$('.precision-container, .abbreviate-values')
				.addClass('is-not-displayed')
		} else {
			this.togglePrecisionSelect()
		}

		this.formView.start()
		return this
	},

	togglePrecisionSelect: function(e) {
		let abbreviateValues = this.$('[name=abbreviateLegendValues]').is(':checked')
		this.$('.select.precision, .precision-container').toggleClass('disabled', abbreviateValues)
	},

	context: function() {
		const titleCode = `charts.chart.settingType.${this.legendType()}Legend`
		return { dialogTitle: i18n.get(titleCode) }
	},

	legendType: function() {
		let legendType = 'color'
		if (this.setting.plotType === 'spike-map') legendType = 'spike'
		if (this.setting.plotType === 'bubble-map') legendType = 'bubble'
		return legendType
	},

	renderDisplayToggle: function() {
		this.displayToggle = new LabeledToggle({
			name: 'legendType',
			value: this.setting.legendType,
			options: this.getOptions()
		})
		this.$('.toggle-container').append(this.displayToggle.el)
		this.displayToggle.render()
		this.displayToggle.on('change', () => this.formView.change())
	},

	getOptions: function() {
		const optionData = enums.toOptionData('chartLegendType')
		const options = _.filter(optionData, opt =>
			opt.id !== 'chart-title' || this.section === 'dashboards')
		return _.map(options, o => ({ value: o.id, label: o.label }))
	},

	renderPrecisionDropdown: function() {
		dropdown.precision(this.$('[name=precision]'))
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.displayToggle], 'remove')
	},

	submit: function() {
		_.extend(this.setting, formHelper.readFromDom(this.el))
		this.trigger('done', this.setting)
	},
})

export default LegendSettings
LegendSettings.__filename__ = 'charts/edit/legend-settings.js'
